import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEnter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"enter, return, keyboard, submit, confirm"} maskId="square-filled-radius-0-stroke-1-IconEnter"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V9H9V3H21V21ZM14.5 14.5H11V12.5L7.5 15L11 17.5V15.5H15.5V9.5H14.5V14.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconEnter;
